/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconHide16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconHide16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m10.552 12.596 1.45 2.07h1.666L4.335 1.334H2.668l1.733 2.475a8.379 8.379 0 0 0-3.733 3.52v1.333a8.375 8.375 0 0 0 9.884 3.935Zm-.808-1.154-.855-1.222a3.67 3.67 0 0 1-4.242-5.042A7.029 7.029 0 0 0 2 7.687l-.166.307.166.308a7.041 7.041 0 0 0 7.743 3.14ZM8.031 8.995l-2.212-3.16a2.333 2.333 0 0 0 2.212 3.16Z"
                fill="currentColor"
            />
            <path
                d="M15.335 8.661a8.375 8.375 0 0 1-2.78 2.986l-.766-1.093a7.042 7.042 0 0 0 2.212-2.252l.167-.308-.167-.307a7.032 7.032 0 0 0-2.645-2.509c.2.454.312.956.312 1.483 0 .927-.344 1.773-.91 2.419l-.802-1.144a2.333 2.333 0 0 0-1.953-3.608h-.002c-.181 0-.358.02-.528.06l-.89-1.272a8.367 8.367 0 0 1 8.752 4.212v1.333Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconHide24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconHide24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.826 18.894 18 22h2.5L6.5 2H4l2.599 3.713A12.566 12.566 0 0 0 1 10.993v2a12.562 12.562 0 0 0 14.826 5.901Zm-1.212-1.731-1.283-1.833a5.5 5.5 0 0 1-6.363-7.562A10.549 10.549 0 0 0 3 11.53l-.25.462.25.462a10.56 10.56 0 0 0 11.614 4.709Zm-2.57-3.671-3.318-4.74a3.5 3.5 0 0 0 3.318 4.74Z"
                fill="currentColor"
            />
            <path
                d="M23 12.992a12.564 12.564 0 0 1-4.17 4.48l-1.148-1.64A10.562 10.562 0 0 0 21 12.454l.25-.462-.25-.462a10.548 10.548 0 0 0-3.968-3.762c.3.68.468 1.433.468 2.224 0 1.39-.516 2.66-1.366 3.628l-1.202-1.716a3.5 3.5 0 0 0-2.93-5.411H12a3.51 3.51 0 0 0-.792.09L9.87 4.672A12.55 12.55 0 0 1 23 10.992v2Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconHide = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconHide(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '16':
            return <IconHide16 {...iconProps} />;
        case '24':
            return <IconHide24 {...iconProps} />;
        default:
            return <IconHide24 {...iconProps} />;
    }
});
